import * as React from 'react';

import { cn } from '@shared/utils/cn';

// Skeleton Minimal : rayon 16px (pilule sur les lignes de texte)
const Skeleton = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div className={cn('animate-pulse rounded-2xl bg-muted-foreground/12', className)} data-slot="skeleton" {...props} />
);

export { Skeleton };
